import { FullScreen } from 'foundations-components/transitional/components/FullScreen';
import { useChosenApps } from 'setup-guide-api/dataFetchingClient/queries/integrations';
import MarketplaceSidePanelContainer from './MarketplaceSidePanelContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const IntegrationsSidePanel = ({
  offeringSlug,
  onClose
}) => {
  const chosenApps = useChosenApps();
  const chosenOfferingIds = chosenApps.map(({
    offeringId
  }) => offeringId);
  return /*#__PURE__*/_jsx(FullScreen, {
    children: /*#__PURE__*/_jsx(MarketplaceSidePanelContainer, {
      offeringSlug: offeringSlug !== null && offeringSlug !== void 0 ? offeringSlug : undefined,
      onClose: onClose,
      pinnedOfferingIds: chosenOfferingIds
    })
  });
};
export default IntegrationsSidePanel;